import React, { Component } from 'react';
import Cookies from 'js-cookie'
import FancyWebSocket from '../../ws_event_dispatcher';
import UA from '../../webrtc';

import { Container, Row, Col, Card } from 'react-bootstrap';

import TopBar from './TopBar';
import Footer from './Footer';
import { Monitor, PTT, Device, DialPad } from './Buttons';
import { AudioConnectionModal } from './AudioConnection';
import { Cobrowse } from './Cobrowse';

import './Console.css';
import ringsoundfile from "./ring.ogg"

export default class Console extends Component {

  ws = null;

  connecionStatusTask = null;

  state = {
    connected: false,
    mediaState: "idle",
    mediaType: null,
    mediaSignalStrength: 0,
    realName: "",
    audioConnectionShow: false,
    pttDisabled: false,
    dialpadDisabled: false,
    transferDisabled: false,
  }

  monitorButtons = [
    {id: 1, keyCode: 49},
    {id: 2, keyCode: 50},
    {id: 3, keyCode: 51},
    {id: 4, keyCode: 52},
    {id: 5, keyCode: 53},
    {id: 6, keyCode: 54},
    {id: 7, keyCode: 55},
    {id: 8, keyCode: 56},
    {id: 9, keyCode: 57},
    {id: 10, keyCode: 58},
    {id: 11, keyCode: 59},
    {id: 12, keyCode: 60},
  ];

  deviceButtons = [
    {id: 1, keyCode: 49},
    {id: 2, keyCode: 50},
    {id: 3, keyCode: 51},
    {id: 4, keyCode: 52},
  ];


  constructor(props) {
    super(props);

    this.ring = this.ring.bind(this);
    this.stopRing = this.stopRing.bind(this);
    this.onResourceStatus = this.onResourceStatus.bind(this);
    this.onConnectionStatus  = this.onConnectionStatus.bind(this);

    this.ringRef = React.createRef();
    this.speakerRef = React.createRef();
    this.monitorRefs = Array(this.monitorButtons.length).fill().map((_, i) => (React.createRef()));
    this.deviceRefs = Array(this.deviceButtons.length).fill().map((_, i) => (React.createRef()));

    this.ringTimeoutTask = null;
    this.userConfig = {};
    this.userConfig = {media: {webrtc: {}, dialin: {number: "123", password: "12321"}}};
    this.ua = null;
  }

  onConnectionStatus = (message) => {
    this.setState({
      connected: message.connected,
    });
  }

  startConnectionStatusTask = () => {
    if (this.connecionStatusTask !== null) return;
    this.connecionStatusTask = setInterval(() => {
      this.requestConnectionStatus();
    }, 30000);
  }

  stopConnectionStatusTask = () => {
    if (this.connecionStatusTask !== null) clearInterval(this.connecionStatusTask);
    this.connecionStatusTask = null;
  }

  onWebSocketConnectionClosed = (message) => {
    this.setState({
      connected: false,
    });
  }

  onMediaConnectionStatus = (message) => {
    let connection_type = message.connected ? message.type : null;
    this.setState({
      mediaState: message.connected ? "connected" : "idle",
      mediaType: connection_type
    });

    if (!message.connected &&
        Cookies.get('media.webrtc-autoconnect') !== "true") {
      this.setState({audioConnectionShow: true });
    }

  }

  onResourceStatus = (message) => {
    if (typeof message.resource.type === 'undefined') return;
    if (typeof message.resource.index === 'undefined') return;

    let ref = null;
    if (message.resource.type === "monitor") ref = this.monitorRefs[message.resource.index];
    else if (message.resource.type === "device") ref = this.deviceRefs[message.resource.index];
    if (ref == null) return;

    let resource_status = message.resource.status;
    if (typeof resource_status === 'undefined') return;

    let status = "idle";
    if (resource_status.focus) status = "focus";
    else if (resource_status.transmitting) status = "transmitting";
    else if (resource_status.ringing) status = "ringing";
    else if (resource_status.talking) status = "talking";
    else if (resource_status.busy) status = "busy";

    if (status === "ringing" && message.resource.endpoint !== 'undefined') {
      status = message.resource.endpoint.direction === "outgoing" ? "calling" : status;
    }

    ref.current.setStatus(status);
    ref.current.setLabel(message.resource.label);

    this.tooglePTT();
    this.toogleDialpad();
    this.toogleTransfer();
  }

  tooglePTT = () => {
    let someoneOnFocus = this.monitorRefs.some((item) => {
      if (item.current == null) return false;
      return !item.current.state.disabled && item.current.state.status === "focus";
    })
    let someMonitorNotIdle = this.monitorRefs.some((item) => {
      if (item.current == null) return false;
      return item.current.state.status !== "idle";
    })
    this.setState({pttDisabled: someoneOnFocus || !someMonitorNotIdle });
  }

  toogleDialpad = () => {
    let someDeviceFree = this.deviceRefs.some((item) => {
      if (item.current == null) return false;
      return item.current.state.status === "idle";
    })
    this.setState({dialpadDisabled: !someDeviceFree});
  }

  toogleTransfer = () => {
    let someMonitorFree = this.monitorRefs.some((item) => {
      if (item.current == null) return false;
      return item.current.state.status === "idle";
    })
    this.setState({transferDisabled: !someMonitorFree});
  }


  onRing = (message) => {
    if (typeof message.action === 'undefined') return;
    if (message.action === "start") this.ring();
    else if (message.action === "stop") this.stopRing();
  }

  onUserConfig = (message) => {
    this.setState({
      realName: message.name
    });

    this.userConfig = message;
    // TODO close old
    if (this.userConfig.media.webrtc !== 'undefined') {
      this.ua = new UA(this.userConfig.media);
      this.ua.on('connected', this.onWebRTCConnected);
      this.ua.on('registered', this.onWebRTCRegistered);
      this.ua.on('unregistered', this.onWebRTCUnregistered);
      this.ua.on('registrationFailed', this.onWebRTCRegistrationFailed);
      this.ua.on('sessionConfirmed', this.onWebRTCSessionConfirmed);
      this.ua.on('sessionEnded', this.onWebRTCSessionEnded);
      this.ua.on('sessionFailed', this.onWebRTCSessionFailed);
      this.ua.on('sessionOnTrack', this.onWebRTCSessionTrack);
      this.ua.on('sessionStats', (data) => this.setState({mediaSignalStrength: data.score}));

      if (Cookies.get('media.webrtc-autoconnect') === "true") this.ua.connect();

      Cobrowse.install(this.userConfig);

      // Development
      window.UA = this.ua;
    }
  }

  connectWebRTC = () => {
    if (this.ua.isConnected()) return;
    this.setState({mediaState: "connecting"})
    this.ua.connect();
  }

  disconnectWebRTC = () => {
    if (!this.ua) return;
    this.ua.close();
  }

  onWebRTCConnected = (e) => {
    console.log("WebRTC connected");
  }

  onWebRTCRegistered = (e) => {
    console.log("WebRTC registered");
  }

  onWebRTCUnregistered = (e) => {
    console.log("WebRTC unregistered");
  }

  onWebRTCRegistrationFailed = (e) => {
    console.log("WebRTC registration failed");
  }

  onWebRTCSessionConfirmed = (e) => {
    console.log("WebRTC session confirmed");
  }

  onWebRTCSessionTrack= (e) => {
    if (typeof this.speakerRef.current === 'undefined') return;
    this.speakerRef.current.srcObject = e.streams[0];
    this.speakerRef.current.play()
  }

  onWebRTCSessionEnded = (e) => {
    if (e.originator == "remote") {
      console.log("WebRTC session ended by remote. Will reconnect...");
      this.ua.call();
    } else {
      console.log("WebRTC session ended locally");
      this.onMediaDisconnected();
      this.ua.close();
    }
  }

  onWebRTCSessionFailed = (e) => {
    console.log("WebRTC session failed");
    this.onMediaDisconnected();
    this.ua.close();
  }

  onMediaDisconnected = () => {
    setTimeout(() => {
      this.state.mediaState !== "idle" && this.setState({mediaState: "idle"})
    }, 2000);
  }

  onMediaStatus = (message) => {
    if (typeof message.resource.type === 'undefined') return;
    if (typeof message.resource.index === 'undefined') return;
    if (typeof message.status === 'undefined') return;

    let refs = [];
    if (message.resource.type === "device") {
      let ref = this.deviceRefs[message.resource.index];
      if (ref == null) return;
      refs.push(ref);
    } else if (message.resource.type === "monitor") {
      refs = this.monitorRefs;
    }
    refs.map((item, idx) => {
      if (item.current == null) return null;
      if (message.status === "connected") item.current.unmute();
      else if (message.status === "disconnected") item.current.mute();
      return item;
    })
  }

  ring = () => {
    if (typeof this.ringRef.current === 'undefined') return;
    this.ringRef.current.currentTime = 0;
    this.ringRef.current.play();
    this.ringTimeoutTask = setTimeout(() => {
      this.stopRing();
      this.ringTimeoutTask = null;
    }, 12000);
  }

  stopRing = () => {
    if (this.ringTimeoutTask !== null) clearTimeout(this.ringTimeoutTask);
    this.ringRef.current.pause();
  }

  requestResourceStatus = (message) => {
    this.ws.request("resource_status", {})
  }

  requestConnectionStatus = (message) => {
    this.ws.request("connection_status", {})
  }

  requestMediaStatus = (message) => {
    this.ws.request("media_status", {})
  }

  requestUserConfig = (message) => {
    this.ws.request("user_config", {})
  }

  requestDial = (number) => {
    this.ws.request("dial", {"endpoint": number})
  }

  componentDidMount = () => {
    this.connect();
    window.addEventListener('beforeunload', this.close);
  }

  componentWillUnmount = () => {
    this.close();
    window.removeEventListener('beforeunload', this.close);
  }

  connect = () => {
    const host = window.location.host;
    const proto = window.location.protocol === "http:" ? "ws" : "wss";

    this.ws = new FancyWebSocket(proto + "://" + host + "/ws");
    this.ws.bind('open', this.requestResourceStatus)
    this.ws.bind('open', this.requestConnectionStatus)
    this.ws.bind('open', this.requestMediaStatus)
    this.ws.bind('open', this.requestUserConfig)
    this.ws.bind('open', this.startConnectionStatusTask)
    this.ws.bind('user_config', this.onUserConfig)
    this.ws.bind('connection_status', this.onConnectionStatus)
    this.ws.bind('resource_status', this.onResourceStatus)
    this.ws.bind('ring', this.onRing)
    this.ws.bind('media_status', this.onMediaStatus)
    this.ws.bind('media_connection_status', this.onMediaConnectionStatus)
    this.ws.bind('close', this.onWebSocketConnectionClosed)
    this.ws.bind('close', this.stopConnectionStatusTask)
  };

  close = () => {
    this.disconnectWebRTC();
  }

  render = () => {
    return (
      <Container fluid className="console-container">
        <audio loop src={ringsoundfile} ref={this.ringRef} />
        <audio ref={this.speakerRef} />
        <AudioConnectionModal show={this.state.audioConnectionShow}
                              onHide={() => this.setState({audioConnectionShow: false})}
                              userConfig={this.userConfig}
                              connectWebRTC={this.connectWebRTC}
                              disconnectWebRTC={this.disconnectWebRTC}
                              mediaState={this.state.mediaState}
                              mediaType={this.state.mediaType}/>
        <TopBar name={this.state.realName}
                connected={this.state.connected}
                showAudioConnection={() => this.setState({audioConnectionShow: true})}
                mediaState={this.state.mediaState}/>
        <Row className="mb-5">
          <Col md="12" lg="8" className="order-2 order-lg-1">
            <Row>
              <Col sm="12">
                <PTT ws={this.ws} disabled={this.state.pttDisabled}/>
              </Col>
            </Row>
            <Row>
              {
                this.monitorButtons.map((item, idx) => {
                  return <Col sm="6" key={idx}>
                           <Monitor
                              ref={this.monitorRefs[idx]}
                              buttonItem={item}
                              ws={this.ws} />
                         </Col>
                })
              }
            </Row>
          </Col>
          <Col md="12" lg="4" className="order-1 order-lg-2">
            <Row>
              <Col sm="12">
                <Card className="card-device mb-2 mt-2 p-2">
                  <DialPad ws={this.ws} disabled={this.state.dialpadDisabled}/>
                  {
                    this.deviceButtons.map((item, idx) => {
                      return <Device
                               key={idx}
                               buttonItem={item}
                               ref={this.deviceRefs[idx]}
                               ws={this.ws}
                               transferDisabled={this.state.transferDisabled}/>
                    })
                  }
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Footer
          mediaType={this.state.mediaType}
          mediaSignalStrength={this.state.mediaSignalStrength}
          connected={this.state.connected}/>
    </Container>
    )
  }
}
